import { render } from "./TestimonialSection.vue?vue&type=template&id=70dbf0fc&scoped=true&ts=true"
import script from "./TestimonialSection.vue?vue&type=script&lang=ts"
export * from "./TestimonialSection.vue?vue&type=script&lang=ts"

import "./TestimonialSection.vue?vue&type=style&index=0&id=70dbf0fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dbf0fc"]])

export default __exports__